/*-
 * #%L
 * Aires Éducatives
 * %%
 * Copyright (C) 2020 - 2023 OFB
 * %%
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 * #L%
 */

// Configuration des icônes FontAwesome pour l'application SAGAE
import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faAddressCard,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowCircleUp,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faAt,
  faAward,
  faBuilding,
  faCalendar,
  faCalendarAlt,
  faCalendarDay,
  faCalendarWeek,
  faCaretDown,
  faCaretLeft,
  faCaretUp,
  faChalkboardTeacher,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChild,
  faCircle,
  faClipboard,
  faClipboardList,
  faCog,
  faCommentAlt,
  faDesktop,
  faEdit,
  faEllipsisH,
  faEnvelope,
  faEnvelopeOpenText,
  faEuroSign,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faFileSignature,
  faFolderOpen,
  faGavel,
  faGraduationCap,
  faHourglassHalf,
  faInfoCircle,
  faMailBulk,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faMinus,
  faNewspaper,
  faPaperPlane,
  faPauseCircle,
  faPencilRuler,
  faPeopleArrows,
  faPhone,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faPowerOff,
  faQuestion,
  faQuestionCircle,
  faRedo,
  faSave,
  faSchool,
  faSearch,
  faSignature,
  faSmile,
  faSpinner,
  faStamp,
  faStopCircle,
  faTimes,
  faTimesCircle,
  faTools,
  faTrash,
  faTrashAlt,
  faUniversity,
  faUpload,
  faUser,
  faUsers,
  faWifi,
} from "@fortawesome/free-solid-svg-icons"

/**
 * Liste complète des icônes FontAwesome utilisées dans l'application
 */
export const allIcons = [
  faAddressCard,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowCircleUp,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faAt,
  faAward,
  faBuilding,
  faCalendar,
  faCalendarAlt,
  faCalendarDay,
  faCalendarWeek,
  faCaretDown,
  faCaretLeft,
  faCaretUp,
  faChalkboardTeacher,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckSquare,
  faChild,
  faCircle,
  faClipboard,
  faClipboardList,
  faCog,
  faCommentAlt,
  faDesktop,
  faEdit,
  faEllipsisH,
  faEnvelope,
  faEnvelopeOpenText,
  faEuroSign,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faFileSignature,
  faFolderOpen,
  faGavel,
  faGraduationCap,
  faHourglassHalf,
  faInfoCircle,
  faMailBulk,
  faMapMarkedAlt,
  faMapMarkerAlt,
  faMinus,
  faNewspaper,
  faPaperPlane,
  faPauseCircle,
  faPencilRuler,
  faPeopleArrows,
  faPhone,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faPowerOff,
  faQuestion,
  faQuestionCircle,
  faRedo,
  faSave,
  faSchool,
  faSearch,
  faSignature,
  faSmile,
  faSpinner,
  faStamp,
  faStopCircle,
  faTimes,
  faTimesCircle,
  faTools,
  faTrash,
  faTrashAlt,
  faUniversity,
  faUpload,
  faUser,
  faUsers,
  faWifi,
]

/**
 * Icônes minimales pour le mode fallback
 */
export const fallbackIcons = [
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faCalendarAlt,
  faCaretDown,
  faCheck,
  faEye,
  faEyeSlash,
  faMinus,
  faPlus,
  faTimes,
  faTrashAlt,
  faUpload,
]

/**
 * Configure FontAwesome avec toutes les icônes de l'application
 */
export function setupFontAwesome(): void {
  library.add(...allIcons)
}

/**
 * Configure FontAwesome avec les icônes minimales (mode fallback)
 */
export function setupFontAwesomeFallback(): void {
  library.add(...fallbackIcons)
}
